export default {
  'menu.signInPage': '从业人员签到',
};